<template>
  <loader v-bind="{ loading }">
    <page-navigation :title="`Apps (${apps.total})`">
      <template #right>
        <search-bar
          v-model="filters.search"
          @run-search="searchForApps"
          @clear-search="clearSearch">
          <template #buttons>
            <router-link
              :to="{ name: 'create-app' }"
              class="is-rounded button">
              <icon icon="plus"/>
              <span>App</span>
            </router-link>
          </template>
        </search-bar>
      </template>
    </page-navigation>  

    <columns>
      <column>
        <index-row 
          :app="app" v-for="app in apps.data" :key="app.id"
          :title="app.name"
          has-avatar
          :avatar="{ path: app.logo_url, name: app.name }"
          :route="{ name: 'app-manager', params: { app: app.id }}">
          <span class="has-text-weight-light">{{ app.domain }}</span>
          <span class="help">last active {{ app.updated_at | asCalendar }}</span>

          <template #right>
            <flex class="mr-5">
              <problem-count :count="app.environments_count" />
            </flex>
            <flex class="mr-5 ml-5">
              <local-env-count :count="app.environments_count" />
            </flex>
            <flex class="mr-5 ml-5">
              <view-app-link :count="app.environments_count" />
            </flex>
          </template>
        </index-row>  
        <pager v-if="apps.next_page_url || apps.prev_page_url" context="app" :pageable="apps" @nav="goTo"/>
        <no-items-to-show v-if="!apps.data.length && !apps.total" text="No Apps Found">
          <router-link
            :to="{ name: 'create-app' }"
            class="is-rounded button">
            <icon icon="plus"/>
            <span>Create an Application</span>
          </router-link>
        </no-items-to-show>  
      </column>
    </columns>
  </loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'Apps',

  data: () => ({
    apps: new Paginator,
    loading: true,
    searching: false,
    filters: {
      search: ''
    }
  }),

  created() {
    if (this.$route.query.search) {
      this.filters.search = this.$route.query.search
    }
    this.loadApps()
  },

  methods: {
    loadApps() {
      getPath({
        path: 'api' + this.$route.fullPath
      }, ({ data }) => {
        this.apps = data
        this.$bus.$emit('set-title', `Apps (${this.apps.total})`)
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    searchForApps() {
      if (!this.filters.search.length) {
        this.$toast.warning('Please enter a search phrase')
        return
      }
      this.$router.push({
        name: 'apps',
        query: {
          search: this.filters.search
        }
      })
    },
    clearSearch() {
      this.filters.search = ''
      this.$router.push({
        name: 'apps',
        query: {}
      })
    }
  },

  watch: {
    '$route': 'loadApps'
  }
}
</script>
